export const LANGUAGES = [
  {
    text: 'Afrikaans',
    value: 'af'
  },
  {
    text: 'Albanian',
    value: 'sq'
  },
  {
    text: 'Amharic',
    value: 'am'
  },
  {
    text: 'Arabic',
    value: 'ar'
  },
  {
    text: 'Armenian',
    value: 'hy'
  },
  {
    text: 'Basque',
    value: 'eu'
  },
  {
    text: 'Bengali',
    value: 'bn'
  },
  {
    text: 'Bulgarian',
    value: 'bg'
  },
  {
    text: 'Catalan',
    value: 'ca'
  },
  {
    text: 'Central Khmer',
    value: 'km'
  },
  {
    text: 'Chamorro',
    value: 'ch'
  },
  {
    text: 'Chinese',
    value: 'zh'
  },
  {
    text: 'Croatian',
    value: 'hr'
  },
  {
    text: 'Czech',
    value: 'cs'
  },
  {
    text: 'Danish',
    value: 'da'
  },
  {
    text: 'Dutch',
    value: 'nl'
  },
  {
    text: 'English',
    value: 'en'
  },
  {
    text: 'Estonian',
    value: 'et'
  },
  {
    text: 'Fijian',
    value: 'fj'
  },
  {
    text: 'Finnish',
    value: 'fi'
  },
  {
    text: 'French',
    value: 'fr'
  },
  {
    text: 'Georgian',
    value: 'ka'
  },
  {
    text: 'German',
    value: 'de'
  },
  {
    text: 'Greek',
    value: 'el'
  },
  {
    text: 'Gujarati',
    value: 'gu'
  },
  {
    text: 'Haitian Creole',
    value: 'ht'
  },
  {
    text: 'Hebrew',
    value: 'he'
  },
  {
    text: 'Hindi',
    value: 'hi'
  },
  {
    text: 'Hungarian',
    value: 'hu'
  },
  {
    text: 'Icelandic',
    value: 'is'
  },
  {
    text: 'Indonesian',
    value: 'id'
  },
  {
    text: 'Irish',
    value: 'ga'
  },
  {
    text: 'Italian',
    value: 'it'
  },
  {
    text: 'Japanese',
    value: 'ja'
  },
  {
    text: 'Korean',
    value: 'ko'
  },
  {
    text: 'Lao',
    value: 'lo'
  },
  {
    text: 'Latin',
    value: 'la'
  },
  {
    text: 'Latvian',
    value: 'lv'
  },
  {
    text: 'Lithuanian',
    value: 'lt'
  },
  {
    text: 'Macedonian',
    value: 'mk'
  },
  {
    text: 'Malay',
    value: 'ms'
  },
  {
    text: 'Malayalam',
    value: 'ml'
  },
  {
    text: 'Maltese',
    value: 'mt'
  },
  {
    text: 'Maori',
    value: 'mi'
  },
  {
    text: 'Marathi',
    value: 'mr'
  },
  {
    text: 'Marshallese',
    value: 'mh'
  },
  {
    text: 'Mongolian',
    value: 'mn'
  },
  {
    text: 'Nepali',
    value: 'ne'
  },
  {
    text: 'Norwegian',
    value: 'no'
  },
  {
    text: 'Panjabi',
    value: 'pa'
  },
  {
    text: 'Persian',
    value: 'fa'
  },
  {
    text: 'Polish',
    value: 'pl'
  },
  {
    text: 'Portuguese',
    value: 'pt'
  },
  {
    text: 'Quechua',
    value: 'qu'
  },
  {
    text: 'Romanian',
    value: 'ro'
  },
  {
    text: 'Russian',
    value: 'ru'
  },
  {
    text: 'Samoan',
    value: 'sm'
  },
  {
    text: 'Serbian',
    value: 'sr'
  },
  {
    text: 'Slovak',
    value: 'sk'
  },
  {
    text: 'Slovenian',
    value: 'sl'
  },
  {
    text: 'Somali',
    value: 'so'
  },
  {
    text: 'Spanish',
    value: 'es'
  },
  {
    text: 'Swahili',
    value: 'sw'
  },
  {
    text: 'Swedish',
    value: 'sv'
  },
  {
    text: 'Tagalog',
    value: 'tl'
  },
  {
    text: 'Tamil',
    value: 'ta'
  },
  {
    text: 'Tatar',
    value: 'tt'
  },
  {
    text: 'Telugu',
    value: 'te'
  },
  {
    text: 'Thai',
    value: 'th'
  },
  {
    text: 'Tibetan',
    value: 'bo'
  },
  {
    text: 'Tonga (Tonga Islands)',
    value: 'to'
  },
  {
    text: 'Turkish',
    value: 'tr'
  },
  {
    text: 'Ukrainian',
    value: 'uk'
  },
  {
    text: 'Urdu',
    value: 'ur'
  },
  {
    text: 'Uzbek',
    value: 'uz'
  },
  {
    text: 'Vietnamese',
    value: 'vi'
  },
  {
    text: 'Welsh',
    value: 'cy'
  },
  {
    text: 'Xhosa',
    value: 'xh'
  }
];
